import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'

import type { RecommendationAction } from 'modules/timeoff/components/LeaveApprovalRecommendation/RecommendationAction'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'
import { trackApprovalRecommendation } from 'modules/timeoff/lib/tracking'
import type Leave from 'modules/timeoff/store/models/Leave'

interface ApproveAndRefreshLeaveParams {
  action: string
  rpcMethod: string
  leave: Leave
  form: LeaveForm
  canUpdate: boolean
  onFetchStats: () => void
  fetchData: (employeeId: string) => void
  closePortal: () => void
  onClose: () => void
  fromShifts?: boolean
  employeeId: string
  recommendationAction?: RecommendationAction
  shouldSaveLeaveBeforeApprove?: boolean
}

export async function approveAndRefreshLeave({
  action,
  rpcMethod,
  leave,
  form,
  canUpdate,
  onFetchStats,
  fetchData,
  closePortal,
  onClose,
  fromShifts = false,
  employeeId,
  recommendationAction,
  shouldSaveLeaveBeforeApprove,
}: ApproveAndRefreshLeaveParams) {
  // Guard: don't attempt to approve an already-approved leave
  if (leave.isApproved()) return

  if (canUpdate && (shouldSaveLeaveBeforeApprove ?? form.isDirty)) {
    const { success } = await asyncAction(() => form.save(leave))
    if (!success) {
      return
    }
  }

  const { success, value } = await asyncAction(() => leave.rpc(rpcMethod))
  if (success) {
    onFetchStats()
    leave.set(value)
    fetchData(employeeId)
    closePortal()
    onClose()
    track(trackingEvents.timeoff.reviewTimeOffRequestSubmit, {
      request_action: action,
      from_shifts: fromShifts,
    })

    if (recommendationAction) {
      trackApprovalRecommendation('approve', recommendationAction)
    }
  }
}
